module.exports = __webpack_public_path__ + "static/media/store-1.23282e99.png";